import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Paper, Tab } from '@mui/material';
import React from 'react';
import Base from "../../Base/views/Base";
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import { useState } from 'react';
import { GetSalaryStructureAction } from '../../../../store/Finance/SalaryStructure/Action';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SoapIcon from '@mui/icons-material/Soap';
import TemplateLandingPage from './Template/TemplateLandingPage';
import LWFLandingPage from './LabourWelfareFound/LWFLandingPage';
import PTLandingPage from './ProfessionalTax/PTLandingPage';
import Others from './OthersFinance';
import { GetPayDateAction } from '../../../../store/Finance/PayDate/Action';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import ECMSConfigFinanceLandingPage from './ECMSFinanceConfig/ECMSFinanceConfig';

const FinanceSettingsLandingPage = () => {

    const [value, setValue] = useState('1');
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(GetSalaryStructureAction());  // Check it is used anywhere or not, if not remove it from store as well
        dispatch(GetPayDateAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const { atsModuleData } = useSelector(
        (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
    );
    const FNFAccess = atsModuleData?.some(
        (item) => item.module_name === "FNF"
    );
    return (
        <Base>
            <Paper className='onboarding-settings admin-setting' sx={{ borderRadius: "10px", minHeight: "87vh", maxHeight: "87vh", overflowY: "auto" }}>
                <TabContext value={value}>
                    <Box
                        sx={{
                            position: "sticky",
                            top: 0,
                            zIndex: 100,
                            backgroundColor: "#ffffff",
                        }}
                    >
                        <TabList
                            sx={{
                                minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                                '& .MuiTabs-indicator': {
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: "center !important",
                                },
                            }}
                            onChange={handleChange} aria-label="lab API tabs example"
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >

                            <Tab icon={<DynamicFeedIcon fontSize='small' />} iconPosition="start" label="Template" value="1" />
                            <Tab icon={<AutoAwesomeIcon fontSize='small' />} iconPosition="start" label="Others" value="2" />
                            <Tab icon={<AccountBalanceWalletIcon fontSize='small' />} iconPosition="start" label="Professional Tax" value="3" />
                            <Tab icon={<SoapIcon fontSize='small' />} iconPosition="start" label="Labour Welfare Fund" value="4" />
                           {FNFAccess && <Tab icon={<RoomPreferencesIcon fontSize='small' />} iconPosition="start" label="ECMS Configuration" value="5" />}
                        </TabList>
                    </Box>
                    <TabPanel value="1" sx={{ padding: "0px", minHeight: "45px" }}>
                        <TemplateLandingPage />
                    </TabPanel>
                    <TabPanel value="2" sx={{ padding: "0px", minHeight: "45px" }}>
                        <Others />
                    </TabPanel>
                    <TabPanel value="3" sx={{ padding: "0px", minHeight: "45px" }}>
                        <PTLandingPage />
                    </TabPanel>
                    <TabPanel value="4" sx={{ padding: "0px", minHeight: "45px" }}>
                        <LWFLandingPage />
                    </TabPanel>
                    <TabPanel value="5" sx={{ padding: "0px", minHeight: "45px" }}>
                        <ECMSConfigFinanceLandingPage />
                    </TabPanel>
                </TabContext>
            </Paper>
        </Base>
    );
}

export default FinanceSettingsLandingPage;
